import { AlpineComponent } from '@alpinejs/csp';
import { debounce } from 'debounce';

const DownloadForm = (): AlpineComponent => ({
  init() {
    // setTimeout(() => this.checkHeight(), 2000);
    // setInterval(() => this.checkHeight(), 10000);
    // window.addEventListener('resize', () => debounce(this.checkHeight(), 2000));
  },
  checkHeight() {
    // const iframe = this.$refs.iframe as HTMLIFrameElement;
    // iframe.height = `${iframe.contentWindow?.document.body.scrollHeight}px`;
  }
});

export default DownloadForm;
